var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      { staticClass: "login-form", on: { submit: _vm.login } },
      [
        !_vm.twoFactor && !_vm.secureKey
          ? [
              _c("h1", [_vm._v("Log In")]),
              _vm._v(" "),
              _c("h1", { staticClass: "loginWelcome" }, [
                _vm._v("Welcome back, sign in below using your credentials.")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "Email" } }, [_vm._v("Email ")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.email.value,
                      expression: "form.email.value"
                    }
                  ],
                  ref: "email",
                  staticClass: "form-control",
                  attrs: {
                    tabindex: "0",
                    "aria-describedby": "form_email_required form_email_regex",
                    autocomplete: "email",
                    autofocus: "",
                    id: "Email",
                    name: "Email",
                    placeholder: "Email",
                    type: "email"
                  },
                  domProps: { value: _vm.form.email.value },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form.email, "value", $event.target.value)
                      },
                      function($event) {
                        return _vm.singleValid("email")
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.form.email.showError &&
                        _vm.form.email.errorType == "required",
                      expression:
                        "form.email.showError && form.email.errorType == 'required'"
                    }
                  ],
                  ref: "emailRequiredValMsg",
                  staticClass: "text-danger",
                  attrs: {
                    id: "form_email_required",
                    role: "alert",
                    "aria-live": "polite"
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.form.email.showError &&
                        _vm.form.email.errorType == "regex",
                      expression:
                        "form.email.showError && form.email.errorType == 'regex'"
                    }
                  ],
                  ref: "emailRegexValMsg",
                  staticClass: "text-danger",
                  attrs: {
                    id: "form_email_regex",
                    role: "alert",
                    "aria-live": "polite"
                  }
                })
              ]),
              _vm._v(" "),
              !_vm.sso
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "Password" } }, [
                      _vm._v("Password ")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.password.value,
                          expression: "form.password.value"
                        }
                      ],
                      ref: "password",
                      staticClass: "form-control",
                      attrs: {
                        tabindex: "0",
                        "aria-describedby": "form_password",
                        autocomplete: "current-password",
                        "data-val": "true",
                        id: "Password",
                        name: "Password",
                        placeholder: "Password",
                        type: "password"
                      },
                      domProps: { value: _vm.form.password.value },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form.password,
                              "value",
                              $event.target.value
                            )
                          },
                          function($event) {
                            return _vm.singleValid("password")
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.form.password.showError &&
                            _vm.form.password.errorType == "required",
                          expression:
                            "form.password.showError && form.password.errorType == 'required'"
                        }
                      ],
                      ref: "passwordRequiredValMsg",
                      staticClass: "text-danger",
                      attrs: {
                        id: "form_password",
                        role: "alert",
                        "aria-live": "polite"
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { attrs: { id: "reCaptcha" } }),
              _vm._v(" "),
              !_vm.sso
                ? _c("div", { staticClass: "linkx-box" }, [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.rememberme.value,
                              expression: "form.rememberme.value"
                            }
                          ],
                          attrs: {
                            id: "RememberMe",
                            name: "RememberMe",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.form.rememberme.value)
                              ? _vm._i(_vm.form.rememberme.value, null) > -1
                              : _vm.form.rememberme.value
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.form.rememberme.value,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form.rememberme,
                                      "value",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form.rememberme,
                                      "value",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form.rememberme, "value", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(
                          "\n                        Remember Me\n                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn login-btn",
                  attrs: { disabled: _vm.loader || !_vm.form.valid }
                },
                [
                  !_vm.loader
                    ? [_vm._v("\n                    Log in\n                ")]
                    : [_c("span", { staticClass: "spinner" })]
                ],
                2
              ),
              _vm._v(" "),
              _vm.autoSso === "true"
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "forgot identityProvider",
                        attrs: { href: "/account/signin?autoSso=true" }
                      },
                      [_vm._v("Sign in via your Identity Provider")]
                    )
                  ]
                : [
                    _c(
                      "a",
                      {
                        staticClass: "forgot identityProvider",
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.sso = !_vm.sso
                          }
                        }
                      },
                      [
                        !_vm.sso
                          ? [
                              _vm._v(
                                "\n                        Sign in via your Identity Provider\n                    "
                              )
                            ]
                          : [
                              _vm._v(
                                "\n                        I want to use password sign-in\n                    "
                              )
                            ]
                      ],
                      2
                    )
                  ]
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.twoFactor
          ? [
              _c("h1", [_vm._v("Two-Factor Authentication")]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "AutenticationCode" } }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.autenticationCode.value,
                      expression: "form.autenticationCode.value"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    autocomplete: "off",
                    id: "AutenticationCode",
                    name: "AutenticationCode",
                    placeholder: _vm.twoFactorRecovery
                      ? "Recovery Code"
                      : "Authentication Code",
                    type: "text",
                    maxlength: _vm.twoFactorRecovery ? 24 : 6
                  },
                  domProps: { value: _vm.form.autenticationCode.value },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.form.autenticationCode,
                          "value",
                          $event.target.value
                        )
                      },
                      function($event) {
                        return _vm.singleValid("autenticationCode")
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _vm.form.autenticationCode.showError
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v("Incorrect authentication code. "),
                      _c("br"),
                      _vm._v(
                        " Please make sure your authenticator device is set to the correct time."
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "signin-buttons" }, [
                _c("div", { staticClass: "left" }, [
                  _c(
                    "a",
                    {
                      staticClass: "forgot",
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.twoFactorRecovery = !_vm.twoFactorRecovery
                        }
                      }
                    },
                    [
                      _vm.twoFactorRecovery
                        ? [
                            _vm._v(
                              "\n                            Enter the authentication code.\n                        "
                            )
                          ]
                        : [
                            _vm._v(
                              "\n                          Can't access your phone?\n                        "
                            )
                          ]
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn login-btn",
                      attrs: { disabled: _vm.loader || !_vm.form.valid }
                    },
                    [
                      !_vm.loader
                        ? [_vm._v("Sign in")]
                        : [_c("span", { staticClass: "spinner" })]
                    ],
                    2
                  )
                ])
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.secureKey
          ? [
              _c("img", {
                staticClass: "secure-key-image",
                attrs: {
                  src: "/Content/images/U2F-Image.png",
                  alt: "secure key"
                }
              }),
              _vm._v(" "),
              _vm._m(1)
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "forgot" }, [
      _c(
        "a",
        { staticClass: "forgot", attrs: { href: "/account/forgotpassword/" } },
        [_vm._v("Forgot password?")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-danger text-center" }, [
      _vm._v("Please insert your U2F security key."),
      _c("br"),
      _vm._v(" If exists tap to security key button.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }